<div *ngIf="showBanner" class="nx-margin-left-s nx-margin-right-s">
    <nx-message-banner class="yellow-banner nx-margin-top-s nx-margin-bottom-s " nxContext="warning"
        closeButtonLabel="Close warning message banner" *ngIf="warningBanner" (close)="closeBanner();">
        <span class="message-yello-color">{{maintenanceBannerText}}</span>
    </nx-message-banner>
</div>